import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import SendDeletionRequestRecord from './data/SendDeletionRequestRecord';
import SendDeletionRequestConstants from './constants';

function getInitialState() {
  return new SendDeletionRequestRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<SendDeletionRequestRecord> = (state = defaultState, action) => {
  switch (action.type) {
    case SendDeletionRequestConstants.SEND_DELETION_REQUEST_REQUEST:
      return state.setLoading(true).merge({ error: undefined });

    case SendDeletionRequestConstants.SEND_DELETION_REQUEST_REQUEST_SUCCESS:
      return state.setLoading(false);

    case SendDeletionRequestConstants.SEND_DELETION_REQUEST_REQUEST_ERROR:
      return state.setLoading(false).merge({
        error: new ErrorRecord(
          typeof action.error === 'object' && action.error !== null ? action.error : undefined
        ),
      });

    case SendDeletionRequestConstants.OPEN_MODAL:
      return state.setModalOpen(true);

    case SendDeletionRequestConstants.CLOSE_MODAL:
      return state.setModalOpen(false).merge({ error: undefined });

    default:
      return state;
  }
};

export default reducer;
